import { IPost } from './../models/post.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PostService {


  constructor(private http: HttpClient) {}

  getPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/v1/post/all`, {'headers': headers});
  }

  query(page: number, size: number): Observable<any> {
    return this.http.get<any>(`${environment.url}/post` + (size ? '?page=' + page + '&size=' + size : ''));
  }

  getPostwithGitftcard(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/post/withGitftcard`, {'headers': headers});
  }

  getPostWithoutGitftcard(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/post/withoutGitftcard`, {'headers': headers});
  }

  getPostBycurrentSearch(search: string, page: number, size: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get<any>(`${environment.url}/post` + ('/_search?search=name:' + search + '&page=' + page + '&size=' + size), {'headers': headers});
  }

  savePost(Post: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/post`, Post, {'headers': headers});
  }

  savePostBack(Post: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.post<any>(`${environment.url}/post/back`, Post, {'headers': headers});
  }


  getIdPost(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/post/` + idA, {'headers': headers});
  }

  getIdPostBack(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/post/back/` + idA +`?fields=postSubProducts,subProduct`, {'headers': headers});
  }

  getPostByCategory(idCat: any): Observable<any> {
    return this.http.get<any>(`${environment.url}/post/category/` + idCat);
  }

  updatePost(post: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post/` + post.id, post, {'headers': headers});
  }

  updatePostBack(post: IPost) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post/back/` + post.id, post, {'headers': headers});
  }
  
  activePost(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post/active/${id}`, null,  {'headers': headers});
  }

  activePostBack(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post/back/active/${id}`, null,  {'headers': headers});
  }

  inactivePost(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.put<any>(`${environment.url}/post/inactive/${id}`, null,  {'headers': headers});
  }

  getPostJobByDate(startDate: any, endDate: any ,page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/job/job-post-between-dates?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  deletePost(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/post/` + idA, {'headers': headers});
  }

  deletePostGiftCard(idA: number) {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.delete(`${environment.url}/post/gift-card/` + idA, {'headers': headers});
  }

  getAllPostProductGiftCardByShopId(shopID: string): Observable<any>{
    return this.http.get(`${environment.url}/post/post-product/${shopID}?fields=postProducts,category,status`);
  }

  getAllPostProductPassByShopId(shopID: string): Observable<any>{
    return this.http.get(`${environment.url}/post/post-product-pass/${shopID}?fields=postSubProducts,category,status`);
  }

  allSubscribePostsByDate(startDate: any, endDate: any, page: number, size: number): Observable<any>{
    return this.http.get(`${environment.url}/v1/posts/subscribe/all?fields=postProducts,postServiceModels,postSubProducts&startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`);
  }

  allPosts(page: number, size: number): Observable<any>{
    return this.http.get(`${environment.url}/v1/posts/subscribe/all?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`);
  }

  allPosts_v1(
    page: number, 
    size: number, 
    startDate?: string, 
    endDate?: string, 
    postSearchText: string = '', 
    statusSearchText: string = ''
  ): Observable<any> {
    
    // Préparer les paramètres de date (format ISO)
    let url = `${environment.url}/v1/posts/subscribe/all?fields=postProducts,postServiceModels,postSubProducts&page=${page}&size=${size}`;
    
    // Ajouter les dates si elles sont présentes
    if (startDate) {
      url += `&startDate=${encodeURIComponent(startDate)}`;
    }
    
    if (endDate) {
      url += `&endDate=${encodeURIComponent(endDate)}`;
    }
  
    // Ajouter les paramètres de recherche textuelle
    url += `&postSearchText=${encodeURIComponent(postSearchText)}&statusSearchText=${encodeURIComponent(statusSearchText)}`;
  
    return this.http.get(url);
  }
  
  

  getTopTenViewPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/most_view?fields=postServiceModels,postPromotions,postSubProducts`);
  }

  getMostSellingPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/most_selling?fields=postServiceModels,postPromotions,postSubProducts`);
  }

  getStatByCategorie(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/stat_by_category`);
  }

  getMostCommentPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/most_comment?fields=postServiceModels,postPromotions,postSubProducts`);
  }

  getNumberCandidateByJobPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/number_job_apply?fields=postServiceModels,postPromotions,postSubProducts`);
  }

  getNumberLikedByPost(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/v1/posts/number_post_liked?fields=postServiceModels,postPromotions,postSubProducts`);
  }

  allPostsPromotions_v2(page: number, size: number, minPrice: number, maxPrice: number, isFilterByProductAndService: boolean, isFilterByService: boolean, isFilterByProduct: boolean, isCheckedAnnoncePromotion: boolean, isCheckedAnnonceVedette: boolean, searchText: any): Observable<any>{
    return this.http.get(`${environment.url}/v1/kahpoo/posts/allkahoopost?fields=postServiceModels,postPromotions,postSubProducts&postSearchText=${searchText}&page=${page}&size=${size}&minPrice=${minPrice}&maxPrice=${maxPrice}&isFilterByProductAndService=${isFilterByProductAndService}&isFilterByService=${isFilterByService}&isFilterByProduct=${isFilterByProduct}&isCheckedAnnoncePromotion=${isCheckedAnnoncePromotion}&isCheckedAnnonceVedette=${isCheckedAnnonceVedette}`);
  }

  //api/promotion/product
  isKahpooProductPromotion(): Observable<any>{
    return this.http.get(`${environment.url}/promotion/kahpoo/product`);
  }

  //api/promotion/service
  isKahpooServicePromotion(): Observable<any>{
    return this.http.get(`${environment.url}/promotion/kahpoo/service`);
  }
}


